var content = require("!!../../../../../../node_modules/css-loader/dist/cjs.js??ref--10-oneOf-1-1!../../../../../../node_modules/stylus-loader/index.js??ref--10-oneOf-1-2!./table.styl");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
